import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React from "react";

const PriceCodeNotFound = ({
  priceCodeModalVisible,
  setPriceCodeModalVisible,
}) => {
 

  const handleModalClose = () => {
    setPriceCodeModalVisible(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={priceCodeModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!priceCodeModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column  gap-2"
            style={{
              borderRadius: "12px",
              backgroundImage:
                "radial-gradient(circle at left top, #fff, #fff)",
            }}
          >
            <div
              className="flex justify-content-between align-items-center gap-2 border-round-top"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #1752AA, #1752AA)",
              }}
            >
              <p></p>
              <p className=" text-3xl text-primary-50 font-semibold">
                Tariff Not Found
              </p>
              <div className="mx-4 my-2">
                <i
                  className="pi pi-times"
                  onClick={(e) => hide(e)}
                  style={{ fontSize: "25px", color: "red", cursor: "pointer" }}
                ></i>
              </div>
            </div>

            <div
              className="h-20rem scroll-bar mb-2"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="py-4 px-4">
                <div>
                  <div
                    style={{ marginTop: 5, marginBottom: 10, maxHeight: 500 }}
                  >
                    <div
                      className="flex flex-row border-bottom-1 justify-content-between align-items-center text-center"
                    >
                      <div className="flex-1">
                        <div>
                          <p className="text-xl font-medium">
                            Please Try Again
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      ></Dialog>
    </div>
  );
};

export default PriceCodeNotFound;
